module.exports = "/lucky-balls/img/weager/balls/color/blue.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/color/blue.png
// module id = 1177
// module chunks = 0